module.exports = __webpack_public_path__ + "img/com7-bk.1f56ec88.svg";